/**
 * Impressão "leve" do navegador: só sinais que já estão disponíveis sem pedir
 * nenhuma permissão (nada de câmera/mic/geolocalização, nada de canvas). Não
 * identifica a pessoa — serve só pro servidor notar quando a mesma combinação
 * aparece vindo de muitos IPs diferentes rápido demais (ver `server/antibot.ts`).
 */
export async function computeFingerprint(): Promise<string> {
  try {
    const parts = [
      navigator.userAgent,
      navigator.language,
      `${screen.width}x${screen.height}`,
      String(screen.colorDepth),
      String(new Date().getTimezoneOffset()),
      String(navigator.hardwareConcurrency ?? ""),
      navigator.platform ?? "",
    ].join("|");
    const bytes = new TextEncoder().encode(parts);
    const digest = await crypto.subtle.digest("SHA-256", bytes);
    return Array.from(new Uint8Array(digest))
      .map(byte => byte.toString(16).padStart(2, "0"))
      .join("");
  } catch {
    return "";
  }
}
